import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(
    private alertController: AlertController,
    private languageService: LanguageService
  ) { }

  async show(header: string, message: string) {

    let okbtn = this.languageService.getTranslation('buttons.ok', 'OK');
    const alert = await this.alertController.create({
      header,
      message,
      buttons: [okbtn]
    });

    await alert.present();

    await alert.onDidDismiss();
  }

  async confirm(header: string, message: string) {
    let result = false;
    let okbtn = this.languageService.getTranslation('buttons.ok', 'OK');
    let cancelbtn = this.languageService.getTranslation('buttons.cancel', 'Cancel');
    const alert = await this.alertController.create({
      header,
      message,
      buttons: [
        {
          text: cancelbtn,
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            result = false;
          }
        }, {
          text: okbtn,
          handler: () => {
            result = true;
          }
        }
      ]
    });

    await alert.present();

    await alert.onDidDismiss();

    return result;
  }
}
